import './Description.scss';

import { ReactNode } from 'react';

export type DescriptionProps = {
  children: ReactNode;
  id: string;
};

const className = 'c-Description';

export const Description = function ({
  children,
  ...propsRest
}: DescriptionProps) {
  return (
    <div className={className} {...propsRest}>
      {children}
    </div>
  );
};
